export default __webpack_public_path__ + "static/media/CalendarIcon.cf2fb77b.svg";